import { render, staticRenderFns } from "./FormSideBar.vue?vue&type=template&id=357a4fa2&scoped=true"
import script from "./FormSideBar.vue?vue&type=script&lang=ts"
export * from "./FormSideBar.vue?vue&type=script&lang=ts"
import style0 from "./FormSideBar.vue?vue&type=style&index=0&id=357a4fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a4fa2",
  null
  
)

export default component.exports